/**
 * Theme Requirements Aggregation for Amc
 * 
 * Extends the base preferred theme requirements with Amc specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-preferred/requirements';

/**
 * Amc component requirement overrides.
 * Add requirements for any override components here.
 */
const amcpreferredthemeOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Amc theme.
 * Inherits from preferred theme and overrides with Amc components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...amcpreferredthemeOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
